import buildInstitutionURL from '$utils/buildInstitutionURL';

/**
 * @param {string} spaceId
 * @param {string} assignmentId
 * @param {Boolean} isEducator
 * @returns URL to the appropriate page in the Aula web app
 */
const buildLti1p3URL = ({ spaceId, assignmentId, isEducator }) => {
  if (isEducator) {
    const pathToSubmissions = `#/dashboard/${spaceId}/journey/assignments/${assignmentId}/submissions`;
    return buildInstitutionURL({ subdomain: null, path: pathToSubmissions });
  }

  const pathToAssignments = `#/dashboard/${spaceId}/journey/assignments`;
  return buildInstitutionURL({ subdomain: null, path: pathToAssignments });
};

export default buildLti1p3URL;
